export default {
  home: 'Login',
  status: 'Verifying',
  quiz: 'Questions',
  clues: 'Clues',
};
